import Tabs from './views/Tabs.c';
export default Tabs;
